import _ from 'lodash'
import { RootState } from '../../types/RootState'

class CompanyCardsSelectors {
  getCompanyCards = (state: RootState) => state.companyCards.companyCards
  getLoading = _.memoize(
    ({ loadingWhenInitial }: { loadingWhenInitial: boolean } = { loadingWhenInitial: true }) =>
      (state: RootState) =>
        loadingWhenInitial
          ? state.companyCards.status === 'initial' || state.companyCards.status === 'loading'
          : state.companyCards.status === 'loading',
    props => !!props?.loadingWhenInitial,
  )
  getInitial = (state: RootState) => state.companyCards.status === 'initial'
  getHasError = (state: RootState) => state.companyCards.status === 'failed'
  getError = (state: RootState) => state.companyCards.error
}

export default new CompanyCardsSelectors()
